import { isStringNullOrUndefinedOrWhiteSpace } from './isStringEmptyOrWhiteSpace';
export const megabytesToBytes = (mb) => mb * 1024 * 1024;
/*
 Converts string to boolean.
 When string is null or undefined or whitespace false is returned, otherwise Boolean(string) is used.
 */
export const stringToBoolean = (str) => {
    if (isStringNullOrUndefinedOrWhiteSpace(str)) {
        return false;
    }
    if (str === 'false') {
        return false;
    }
    return Boolean(str);
};
